import React from 'react';
import Col from '../grid/Col';

var MainWrapper = function MainWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Col, {
    flex: "1 1 auto"
  }, children);
};

MainWrapper.defaultProps = {
  children: null
};
export default MainWrapper;